import type { MockMessage } from "@/dummy";

export const plainText = (s: string) =>
  s
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();

/**
 * The BE seed of a slot thread: the first agent message of the loaded thread whose text is one of the
 * thread's slot texts. It is rendered as the thread's header (in place of the client copy), outside the
 * dated history. `null` when the first agent message is something else.
 */
export function findHeaderSeed(
  messages: readonly MockMessage[],
  copies: readonly { text: string }[],
): MockMessage | null {
  const first = messages.find(
    (m) => m.direction === "OUTBOUND" && !m.system && (m.text ?? "").trim() !== "",
  );
  // Only an automatic (bot / ai) message can be a seed; an operator typing the same words is not.
  if (!first || (first.sender.kind !== "bot" && first.sender.kind !== "ai")) return null;
  const text = plainText(first.text ?? "");
  return copies.some((c) => plainText(c.text) === text) ? first : null;
}
